import { render, staticRenderFns } from "./courseGroup.vue?vue&type=template&id=2b5d8a40"
import script from "./courseGroup.vue?vue&type=script&lang=js"
export * from "./courseGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports